import { render, staticRenderFns } from "./ProductPage.vue?vue&type=template&id=51353361&"
import script from "./ProductPage.vue?vue&type=script&lang=ts&"
export * from "./ProductPage.vue?vue&type=script&lang=ts&"
import style0 from "./ProductPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports